// localStorage 工具函数：读写节点图的位置和连线关系

export interface GraphLocalData {
  positions: Record<number, { x: number; y: number }>   // nodeId -> 位置
  connections: Record<number, Record<number, number>>    // nodeId -> { processIndex -> targetNodeId }
}

const STORAGE_KEY_PREFIX = 'node_graph_'

function getStorageKey(gameId: number): string {
  return `${STORAGE_KEY_PREFIX}${gameId}`
}

export function loadGraphData(gameId: number): GraphLocalData {
  try {
    const raw = localStorage.getItem(getStorageKey(gameId))
    if (raw) {
      return JSON.parse(raw)
    }
  } catch (e) {
    console.error('Failed to load graph data from localStorage:', e)
  }
  return { positions: {}, connections: {} }
}

export function saveGraphData(gameId: number, data: GraphLocalData): void {
  try {
    localStorage.setItem(getStorageKey(gameId), JSON.stringify(data))
  } catch (e) {
    console.error('Failed to save graph data to localStorage:', e)
  }
}

export function saveNodePosition(gameId: number, nodeId: number, x: number, y: number): void {
  const data = loadGraphData(gameId)
  data.positions[nodeId] = { x, y }
  saveGraphData(gameId, data)
}

export function saveConnection(gameId: number, sourceNodeId: number, processIndex: number, targetNodeId: number): void {
  const data = loadGraphData(gameId)
  if (!data.connections[sourceNodeId]) {
    data.connections[sourceNodeId] = {}
  }
  data.connections[sourceNodeId][processIndex] = targetNodeId
  saveGraphData(gameId, data)
}

export function removeConnection(gameId: number, sourceNodeId: number, processIndex: number): void {
  const data = loadGraphData(gameId)
  if (data.connections[sourceNodeId]) {
    delete data.connections[sourceNodeId][processIndex]
    if (Object.keys(data.connections[sourceNodeId]).length === 0) {
      delete data.connections[sourceNodeId]
    }
  }
  saveGraphData(gameId, data)
}

export function removeNodeData(gameId: number, nodeId: number): void {
  const data = loadGraphData(gameId)
  delete data.positions[nodeId]
  delete data.connections[nodeId]
  // 同时清理指向该节点的连线
  for (const srcId of Object.keys(data.connections)) {
    const conns = data.connections[Number(srcId)]
    for (const pIdx of Object.keys(conns)) {
      if (conns[Number(pIdx)] === nodeId) {
        delete conns[Number(pIdx)]
      }
    }
    if (Object.keys(conns).length === 0) {
      delete data.connections[Number(srcId)]
    }
  }
  saveGraphData(gameId, data)
}
